import AutomacaoHub from "@/components/automacao/AutomacaoHub";

const AutomacaoEmpresarial = () => <AutomacaoHub />;

export default AutomacaoEmpresarial;
